(function () {
  'use strict';

  function initStickyAtcBar() {
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;

    var hint    = document.getElementById('sticky-atc-hint');
    var priceEl = document.getElementById('sticky-atc-price');

    var productId    = parseInt(bar.dataset.productId, 10);
    var sizeOptIndex = parseInt(bar.dataset.sizeOptionIndex, 10);
    var hasSizeOption = sizeOptIndex >= 0;

    var productJsonEl = document.querySelector('script[type="application/json"][data-product-json="' + productId + '"]');
    if (!productJsonEl) {
      console.warn('[StickyATC] No se encontró el JSON del producto.');
      return;
    }

    var VARIANTS;
    try {
      VARIANTS = JSON.parse(productJsonEl.textContent).variants;
    } catch (e) {
      console.warn('[StickyATC] Error parseando JSON del producto.', e);
      return;
    }

    // ── Estado ──────────────────────────────────────────────────────
    var selectedOptions = [];
    var isBarVisible    = false;
    var isAdding        = false;
    var isPastMainAtc   = false;

    bar.querySelectorAll('.sticky-atc-bar__size-btn.is-selected').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });

    // ── dataLayer helper ─────────────────────────────────────────────
    function dlPush(obj) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(obj);
    }

    // ── Helpers ─────────────────────────────────────────────────────
    function findVariant(opts) {
      if (!opts || opts.length === 0) return null;
      return VARIANTS.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '{{amount}} €';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return (cents / 100).toFixed(2) + ' \u20AC';
    }

    function readPageVariant() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input) return null;
      var id = parseInt(input.value, 10);
      return VARIANTS.find(function (v) { return v.id === id; }) || null;
    }

    function syncPriceFromPage() {
      var variant = readPageVariant();
      if (variant && priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    // ── Detectar Modales Abiertos ────────────────────────────────────
    function isCartDrawerOpen() {
      return !!document.querySelector('.cart-drawer-modal.cc-popup--visible');
    }

    function isQuickAddOpen() {
      // Detecta cualquier panel de tallas o popup de Quickbuy
      return !!document.querySelector(
        '.qs-sheet.is-active, .qs-sheet.is-open, ' +
        '.quick-size-overlay.is-active, ' +
        '.quickbuy-modal.cc-popup--visible, ' +
        '.cc-popup--visible, ' +
        '[data-quickbuy].is-open'
      );
    }

    // ── Mostrar / ocultar bar ────────────────────────────────────────
    function evaluateVisibility() {
      // 1. Si hay algún carrito o menú de vista rápida abierto, ocultamos
      if (isCartDrawerOpen() || isQuickAddOpen()) {
        hideBar();
        return;
      }

      // 2. Si no hay nada abierto, mostramos según el scroll
      if (isPastMainAtc) {
        showBar();
      } else {
        hideBar();
      }
    }

    function showBar() {
      if (isBarVisible) return;
      isBarVisible = true;
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');

      // ── GA4: impresión del sticky bar ──
      dlPush({
        event: 'sticky_atc_impression',
        sticky_atc_product_id: String(productId)
      });

      if (hasSizeOption) {
        bar.querySelectorAll('.sticky-atc-bar__size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        if (hint) {
          hint.textContent = 'A\u00f1ade tu talla';
          hint.style.color = '';
        }
        syncPriceFromPage();
      }
    }

    function hideBar() {
      if (!isBarVisible) return;
      isBarVisible = false;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    // ── Observar apertura/cierre de modales y quick add ─────────────
    function initModalObservers() {
      var SELECTORS = '.qs-sheet, .quick-size-overlay, .quickbuy-modal, .cc-popup, .cart-drawer-modal';

      // 1) Observa cambios de clase en los paneles que ya existen en el DOM
      function observeEl(el) {
        if (el.__stickyObserved) return;
        el.__stickyObserved = true;
        new MutationObserver(evaluateVisibility)
          .observe(el, { attributes: true, attributeFilter: ['class'] });
      }
      document.querySelectorAll(SELECTORS).forEach(observeEl);

      // 2) Observa el body por si el tema inyecta los paneles dinámicamente
      //    (típico en quick add de productos relacionados)
      new MutationObserver(function (mutations) {
        var needsCheck = false;
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(SELECTORS)) {
              observeEl(node);
              needsCheck = true;
            } else if (node.querySelectorAll) {
              var found = node.querySelectorAll(SELECTORS);
              if (found.length) {
                found.forEach(observeEl);
                needsCheck = true;
              }
            }
          });
          m.removedNodes.forEach(function (node) {
            if (node.nodeType === 1) needsCheck = true;
          });
        });
        if (needsCheck) evaluateVisibility();
      }).observe(document.body, { childList: true, subtree: true });
    }

    // ── Abrir cesta lateral ──────────────────────────────────────────
    function openCartDrawer(sectionsData) {
      if (sectionsData && sectionsData['cart-drawer']) {
        var cartDrawer = document.querySelector('.cart-drawer');
        if (cartDrawer) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
          var newContent = doc.querySelector('.cart-drawer');
          if (newContent) cartDrawer.innerHTML = newContent.innerHTML;
        }
      }

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-link__count, .cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.style.display = '';
          });
        })
        .catch(function () {});

      hideBar();

      document.dispatchEvent(
        new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false })
      );
    }

    // ── AJAX Add to Cart ─────────────────────────────────────────────
    function addToCart(variantId, sizeBtn) {
      if (isAdding) return;
      isAdding = true;

      if (sizeBtn) sizeBtn.classList.add('is-loading');
      if (hint) {
        hint.textContent = 'A\u00f1adiendo...';
        hint.style.color = '#888';
      }

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-drawer');

      fetch('/cart/add.js', { method: 'POST', body: new URLSearchParams(formData) })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add failed ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (sizeBtn) sizeBtn.classList.remove('is-loading');
          if (hint) {
            hint.textContent = '\u2713 A\u00f1adido';
            hint.style.color = '#1a7a4a';
          }

          // ── GA4: añadido al carrito desde sticky bar ──
          dlPush({
            event: 'sticky_atc_add',
            sticky_atc_product_id: String(productId),
            sticky_atc_variant_id: String(variantId)
          });

          openCartDrawer(data.sections);
          setTimeout(function () {
            if (hint) {
              hint.textContent = 'A\u00f1ade tu talla';
              hint.style.color = '';
            }
            isAdding = false;
          }, 2500);
        })
        .catch(function (err) {
          console.error('[StickyATC]', err);
          if (sizeBtn) sizeBtn.classList.remove('is-loading');
          if (hint) {
            hint.textContent = 'Error, int\u00e9ntalo de nuevo';
            hint.style.color = '#c00';
          }
          setTimeout(function () {
            if (hint) {
              hint.textContent = 'A\u00f1ade tu talla';
              hint.style.color = '';
            }
            isAdding = false;
          }, 2000);
        });
    }

    // ── AJAX Add to Cart para botón directo (sin talla) ──────────────
    function addToCartDirect(variantId, btn) {
      if (isAdding) return;
      isAdding = true;

      btn.classList.add('is-loading');
      btn.disabled = true;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-drawer');

      fetch('/cart/add.js', { method: 'POST', body: new URLSearchParams(formData) })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add failed ' + res.status);
          return res.json();
        })
        .then(function (data) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.querySelector('.sticky-atc-bar__btn-text').textContent = '\u2713 A\u00f1adido';

          // ── GA4: añadido al carrito desde sticky bar (sin talla) ──
          dlPush({
            event: 'sticky_atc_add',
            sticky_atc_product_id: String(productId),
            sticky_atc_variant_id: String(variantId)
          });

          openCartDrawer(data.sections);
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.disabled = false;
            btn.querySelector('.sticky-atc-bar__btn-text').textContent =
              (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'A\u00f1adir al carrito';
            isAdding = false;
          }, 2500);
        })
        .catch(function (err) {
          console.error('[StickyATC]', err);
          btn.classList.remove('is-loading');
          btn.disabled = false;
          isAdding = false;
        });
    }

    // ── Click en talla sticky (solo productos con talla) ─────────────
    if (hasSizeOption) {
      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('.sticky-atc-bar__size-btn');
        if (!btn || btn.classList.contains('is-unavailable') || btn.classList.contains('is-loading')) return;

        var value    = btn.dataset.sizeValue;
        var optIndex = parseInt(btn.dataset.sizeOptionIndex, 10);

        btn.classList.add('is-popping');
        btn.addEventListener('animationend', function () { btn.classList.remove('is-popping'); }, { once: true });

        bar.querySelectorAll('.sticky-atc-bar__size-btn').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });

        var pageVariant = readPageVariant();
        if (pageVariant) selectedOptions = pageVariant.options.slice();
        selectedOptions[optIndex] = value;

        selectSizeInPage(value, optIndex);

        // ── GA4: click en talla del sticky bar ──
        dlPush({
          event: 'sticky_atc_click',
          sticky_atc_product_id: String(productId),
          sticky_atc_size: value
        });

        var variant = findVariant(selectedOptions);
        if (!variant || !variant.available) {
          if (hint) {
            hint.textContent = 'Talla agotada';
            hint.style.color = '#c00';
            setTimeout(function () {
              hint.textContent = 'A\u00f1ade tu talla';
              hint.style.color = '';
            }, 1500);
          }
          return;
        }

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        addToCart(variant.id, btn);
      });
    }

    // ── Click en botón ATC directo (productos sin talla) ─────────────
    if (!hasSizeOption) {
      var directBtn = document.getElementById('sticky-atc-btn');
      if (directBtn) {
        directBtn.addEventListener('click', function () {
          if (directBtn.disabled || directBtn.classList.contains('is-loading')) return;
          var variantId = parseInt(directBtn.dataset.variantId, 10);
          if (!variantId) return;

          // ── GA4: click en botón ATC directo del sticky bar ──
          dlPush({
            event: 'sticky_atc_click',
            sticky_atc_product_id: String(productId),
            sticky_atc_size: 'no-size'
          });

          addToCartDirect(variantId, directBtn);
        });
      }
    }

    // ── Sincronizar talla en formulario principal ────────────────────
    function selectSizeInPage(value, optionIndex) {
      document.querySelectorAll(
        'form[action*="/cart/add"] input[type="radio"][data-option-index="' + optionIndex + '"]'
      ).forEach(function (r) {
        if (r.value === value) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      var sel = document.querySelector(
        'form[action*="/cart/add"] select[data-option-index="' + optionIndex + '"], ' +
        'form[action*="/cart/add"] select[name="option' + (optionIndex + 1) + '"]'
      );
      if (sel) {
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // ── IntersectionObserver ÚNICO para el botón principal ───────────
    function initObserver() {
      var mainAtcBtn = document.querySelector(
        '[data-add-to-cart-text]:not(#sticky-atc-btn), ' +
        'form.product-purchase-form button[type="submit"]:not(#sticky-atc-btn)'
      );

      if (!mainAtcBtn) {
        console.warn('[StickyATC] Botón ATC principal no encontrado.');
        return;
      }

      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        isPastMainAtc = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        evaluateVisibility();
      }, { threshold: 0 }).observe(mainAtcBtn);

      window.addEventListener('resize', evaluateVisibility);
    }

    // ── Listeners variante del tema ──────────────────────────────────
    function initVariantListeners() {
      ['variant:changed', 'variantChange'].forEach(function (evtName) {
        document.addEventListener(evtName, function (e) {
          var v = (e.detail && e.detail.variant) ? e.detail.variant : e.detail;
          if (v && v.id && priceEl) priceEl.textContent = formatMoney(v.price);
        });
      });

      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          var v = VARIANTS.find(function (vv) { return vv.id === parseInt(input.value, 10); });
          if (v && priceEl) priceEl.textContent = formatMoney(v.price);
        });
      });
    }

    // ── Listeners cart drawer ────────────────────────────────────────
    function initCartDrawerListeners() {
      ['theme:cart-drawer-open', 'cartDrawerOpen', 'cart:open'].forEach(function (evtName) {
        document.addEventListener(evtName, evaluateVisibility);
      });
      ['theme:cart-drawer-close', 'cartDrawerClose', 'cart:close'].forEach(function (evtName) {
        document.addEventListener(evtName, evaluateVisibility);
      });
    }

    // ── Init ─────────────────────────────────────────────────────────
    syncPriceFromPage();
    initObserver();
    initVariantListeners();
    initCartDrawerListeners();
    initModalObservers();

    console.log('[StickyATC] Iniciado. Modo:', hasSizeOption ? 'tap-to-buy (tallas)' : 'botón ATC directo');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtcBar);
  } else {
    initStickyAtcBar();
  }

})();